import { render, staticRenderFns } from "./ArtWindow.vue?vue&type=template&id=21287974&scoped=true&"
import script from "./ArtWindow.vue?vue&type=script&lang=js&"
export * from "./ArtWindow.vue?vue&type=script&lang=js&"
import style0 from "./ArtWindow.vue?vue&type=style&index=0&id=21287974&prod&lang=css&"
import style1 from "./ArtWindow.vue?vue&type=style&index=1&id=21287974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21287974",
  null
  
)

export default component.exports